<template>
  <div>
    <v-flex>
      <p :class="$modal.modalSmallText">
        Great! Your account has been created.
      </p>
    </v-flex>
    <v-flex :class="$modal.modalSmallButton">
      <BaseButton :button-style="'Teal'"
                  @click="close()">Let's Go</BaseButton>
    </v-flex>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import BaseButton from '@/components/BaseButton';
import authMixins from '@/apps/auth/mixins';

  /**
   * Form to check if phone number exists. On success will store pone data in
   * vuex store for further use.
   */
  @Component({
    name:       'AccountCreated',
    components: { BaseButton },
    mixins:     [
      authMixins.AuthorizationMixin,
    ],
  })
export default class AccountCreated extends Vue {
    /**
     * Emits close event on successful action finish. Close event should be
     * handled on the parent component to close modal.
     * @param data
     */
    handleSuccess(data) {
      this.responseData = data;
      this.$emit('close');
    }
  }
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>




// WEBPACK FOOTER //
// src/apps/auth/components/AccountCreated.vue